// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WorkspaceMemberWithCheckbox__checkbox-c572a1 {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
}

.WorkspaceMemberWithCheckbox__checkbox-view-d29c3c {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  margin-inline-end: 6px;
  border-radius: 50%;
  border: 2px solid var(--base-60);
  box-sizing: border-box;
}

.WorkspaceMemberWithCheckbox__selected-a79695 {
  width: 24px;
  height: 24px;
  border: none;
  background-color: var(--brand-primary-40);
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/components/SelectWorkspaceMembers/WorkspaceMemberWithCheckbox/WorkspaceMemberWithCheckbox.style.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,gCAAA;EACA,sBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,yCAAA;AACF","sourcesContent":[".checkbox {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  clip: rect(0 0 0 0);\n}\n\n.checkbox-view {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 24px;\n  height: 24px;\n  margin-inline-end: 6px;\n  border-radius: 50%;\n  border: 2px solid var(--base-60);\n  box-sizing: border-box;\n}\n\n.selected {\n  width: 24px;\n  height: 24px;\n  border: none;\n  background-color: var(--brand-primary-40);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkbox": `WorkspaceMemberWithCheckbox__checkbox-c572a1`,
	"checkbox-view": `WorkspaceMemberWithCheckbox__checkbox-view-d29c3c`,
	"checkboxView": `WorkspaceMemberWithCheckbox__checkbox-view-d29c3c`,
	"selected": `WorkspaceMemberWithCheckbox__selected-a79695`
};
module.exports = ___CSS_LOADER_EXPORT___;
